import React from "react";
import { Box } from "@mui/material";
import { joinModelPath } from "./modelPath";
import type { SpecsFormEntry } from "./types";

function getGridTemplate(columns = 1) {
  if (columns <= 1) {
    return undefined;
  }

  return {
    xs: "1fr",
    lg: `repeat(${columns}, minmax(0, 1fr))`,
  };
}

function getEntryColSpan(entry: SpecsFormEntry, columns = 1) {
  const requestedSpan = entry.colSpan ?? 1;
  if (columns <= 1 || requestedSpan <= 1) {
    return undefined;
  }

  return {
    xs: "span 1",
    lg: `span ${Math.min(requestedSpan, columns)}`,
  };
}

export default function SpecsFormEntriesGrid({
  entries,
  basePath,
  columns = 1,
  renderEntry,
}: {
  entries: SpecsFormEntry[];
  basePath: string;
  columns?: number;
  renderEntry: (entry: SpecsFormEntry) => React.ReactNode;
}) {
  return (
    <Box
      sx={{
        display: "grid",
        gap: 2,
        gridTemplateColumns: getGridTemplate(columns),
      }}
    >
      {entries.map((entry) => (
        <Box
          key={joinModelPath(basePath, entry.path)}
          sx={{
            minWidth: 0,
            gridColumn: getEntryColSpan(entry, columns),
            alignSelf: entry.alignSelf,
          }}
        >
          {renderEntry(entry)}
        </Box>
      ))}
    </Box>
  );
}
